import React, { useState, useRef } from 'react';

import PartialCTA from './cta';

const AccordionItem = ({ item, isStyle4 }) => {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');

  const content = useRef(null);

  function toggleAccordion() {
    const scrollHeight = content.current ? content.current.scrollHeight : 0;
    setActiveState(setActive === '' ? ' is-active' : '');
    setHeightState(setActive === ' is-active' ? '0px' : `${scrollHeight}px`);
  }

  const additionalAccordionProps = {};
  if (typeof item.title_id === 'string' && item.title_id.length > 0) {
    additionalAccordionProps.id = item.title_id;
  }

  return (
    <div
      className={`accordion${setActive}`}
      {...additionalAccordionProps}
    >
      <h3
        className='title'
        onClick={toggleAccordion}
        style={
          isStyle4
            ? {
                backgroundImage: 'none',
                paddingInline: 0,
              }
            : {}
        }
      >
        {item.title_icon && (
          <img
            src={item.title_icon}
            alt={item.title}
            title={item.title}
          />
        )}
        {item.title && item.title}
      </h3>
      <div
        className='content-wr'
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
      >
        <div
          className='content'
          style={
            isStyle4
              ? {
                  paddingLeft: 0,
                }
              : {}
          }
        >
          {item.text && (
            <div
              className='text-formatted'
              dangerouslySetInnerHTML={{ __html: item.text }}
            ></div>
          )}
          {item.cta_field && <PartialCTA data={item.cta_field} />}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
